export default __webpack_public_path__ + "content/media/2.2a03c86e.jpg";